import axios, { Method } from 'axios'
import axiosRetry from 'axios-retry'

import { Config } from 'constants/data'

const { HEADERS } = Config

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

interface IRequest {
  url: string
  method: Method
  data?: any
  params?: any
  headers?: any
}

const request = async ({
  url = '/',
  method = 'get',
  params = {},
  data = {},
  headers = HEADERS,
}: IRequest) => {
  try {
    return await axios({ url, method, params, data, headers: { ...HEADERS, ...headers } })
  } catch (err) {
    console.log(err)
    throw Error
  }
}

export default request
